import React from 'react';



import "@fontsource/mulish"; // Defaults to weight 400.


import Button from '@material-ui/core/Button';
import InfoNode from './InfoNode';

import AppHeader from './AppHeader';

import { makeStyles } from '@material-ui/core/styles';


import {  useHistory } from 'react-router-dom';

var store = require('store');


const useStyles = makeStyles(theme => ({   
  primaryButton: {
    backgroundColor: '#5CD6D2',
    color: 'white',      
    fontWeight: 'bold',
    marginTop: '.5em',
    marginLeft: '.5em',
    '&:hover': {
      backgroundColor: '#FFC24C',
      color: 'black',
    }

  }, 

  topButtonRow: {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'flex-end',    
    marginRight: '0.5em',
  },

  }));



function AllData(props) {

const classes = useStyles();

let history = useHistory();

const jsonObject =  props.location.state.jsonObject;
const fieldSet = props.location.state.fieldSet;



const loadDisplayNamesFromLocalStorage = () => {
  var dict = {};
  if (store.get("displayNameDict"))
      dict =JSON.parse(store.get("displayNameDict"));

  return dict;
}

const displayNameDict = loadDisplayNamesFromLocalStorage();



const setAndPersistDisplayName = (dataField, displayName) => {
  console.log("set displayName", dataField, displayName);
  displayNameDict[dataField] = displayName;
  store.set("displayNameDict", JSON.stringify(displayNameDict));
}


const addDataField = (dataField) => { 
  fieldSet.add(dataField);
  // console.log("Added ", dataField)
  console.log("dialog set upen")
  persistDataFields(fieldSet);
}  

const removeDataField = (dataField) => {
  fieldSet.delete(dataField);
  // console.log("Removed ", dataField)
  persistDataFields(fieldSet);
}  

const persistDataFields = (fieldSet) => {
  // console.log("All fields: ", JSON.stringify([...fieldSet])); //deconstruct (spread) into array
  store.set("fieldSet", JSON.stringify([...fieldSet]));
}
   
const removeAllCustomFields = () => {
  store.remove('fieldSet');
  store.remove('displayNameDict');
  history.goBack();
}




  return (  
        
    <div>             

    <AppHeader backButton={true}/>

      {/* <Button  variant="contained" color="primary" className={classes.primaryButton} onClick={_=>history.goBack()} >
            Tilbake
        </Button>         */}

        <div className={classes.topButtonRow}> 
          <Button onClick={removeAllCustomFields} color="primary" className={classes.primaryButton}> 
            Tilbakestill alle
          </Button>
        </div>

        <InfoNode jsonObject={jsonObject} title="Alle Data" depth={0} nodePath="" fieldSet={fieldSet} 
           addDataField={addDataField} removeDataField={removeDataField} setDisplayName={setAndPersistDisplayName}/>

        

    </div>
  );
}


export default AllData;
